/**
 * Created by JackCui on 2022/3/16
 */

export default {
  // 采购商 供应商 获取系统配置金额数字的精度
  purDigits: {
    url: '/purchaser/overall/configure',
    type: 'GET',
    parameter: {}
  },
  surDigits: {
    url: '/supplier/overall/configure',
    type: 'GET',
    parameter: {}
  },
  mallDigits: {
    url: '/mall/overall/configure',
    type: 'GET',
    parameter: {}
  }
}
